import { useMutation } from "react-relay-mutation";
import { graphql } from "react-relay";
import {
  EmailFeedbackInput,
  useEmailFeedbackMutation as Mutation,
  useEmailFeedbackMutationResponse as Response,
} from "@generated/useEmailFeedbackMutation.graphql";

type Return = [
  ({ message, files }: EmailFeedbackInput) => Promise<Response>,
  { error: Error | null | undefined },
];

type Callback = (result: { error?: string | null }) => void;

export const useEmailFeedbackMutation = (cb: Callback): Return => {
  const [mutation, { error }] = useMutation<Mutation>(
    graphql`
      mutation useEmailFeedbackMutation($input: EmailFeedbackInput!) {
        emailFeedback(input: $input) {
          error
        }
      }
    `,
    {
      onCompleted: ({ emailFeedback: result }) => {
        if (result?.error) {
          cb({ error: result.error || "No response from operation" });
        } else {
          cb({ error: null });
        }
      },
    },
  );

  const updateSettings = ({ message, files }: EmailFeedbackInput) =>
    mutation({
      variables: {
        input: {
          message,
          files,
        },
      },
    });

  return [updateSettings, { error }];
};
